import {
  EU_SUPPLIER_ARCHIVED_LIST,
  EU_SUPPLIER_PENDING_APPROVAL_LIST,
  EU_SUPPLIER_SUBMITTED_TO_EU_LIST,
} from 'Action/types';

const initialState = {
  euPendingApprovalList: null,
  euSubmittedToEuList: null,
  euArchivedList: [],
};

export default (state: any, action: any) => {
  if (!state) {
    state = initialState;
  }
  switch (action.type) {
    case EU_SUPPLIER_PENDING_APPROVAL_LIST:
      return {
        ...state,
        euPendingApprovalList: action.payload,
      };
    case EU_SUPPLIER_SUBMITTED_TO_EU_LIST:
      return {
        ...state,
        euSubmittedToEuList: action.payload,
      };
    case EU_SUPPLIER_ARCHIVED_LIST:
      return {
        ...state,
        euArchivedList: action.payload,
      };
    default:
      return state;
  }
};
